import React from 'react';
import AuthProvider from '../../State/Auth';
import SnackbarProvider from '../../State/Snackbar/SnackbarProvider';

interface GlobalProvidersProps {
  token: string;
  children: React.ReactNode;
}

const GlobalProviders = ({ token, children }: GlobalProvidersProps) => (
  <SnackbarProvider>
    <AuthProvider token={token}>{children}</AuthProvider>
  </SnackbarProvider>
);

export default GlobalProviders;
